if (document.getElementById('vue-payment')) {
	Vue.use(VeeValidate);
	new Vue({
		delimiters: ['[[', ']]'],
		mixins: [baseMixin, eventHubMixin, headerMixin, languageMixin, apiMixin],
		el: '#vue-payment',
		data: {
			residentId: null,
			record: {},
			user: {},
			paymentGateway: {},
			articles: [],
			amount: {},
			queryStringParams: {},
			transactionInit: false,
			notifications: []
		},
		created() { },
		mounted() {
			if (window.hasOwnProperty('token')) {
				localStorage.setItem('token', window.token);
				this.setUser();
			}
			this.queryStringParams = getQueryStringParameters();
			if (!this.queryStringParams.hasOwnProperty('partial')) {
				this.amount.value = this.$refs.amountInput.value;
				this.createTransaction();
			}
			this.user = JSON.parse(localStorage.getItem('user'));
		},
		computed: {
			renderAmount() {
				if (this.amount.value) {
					return this.amount.value.replace('.', ',') + '€';
				}
			}
		},
		methods: {
			createTransaction() {
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.post('create-transaction', { amount: this.amount.value })
							.then((response) => {
								// console.log(response);
								this.transactionInit = true;
								this.paymentGateway = response.data;
							})
							.catch((error) => {
								// console.log(error);
							});
					}
				});
			},
			// getRecords() {
			// 	this.get('residents/' + this.user.id + '/application')
			// 		.then((response) => {
			// 			this.record = response.data;
			// 		})
			// 		.catch((error) => {
			// 			// console.log(error);
			// 		});
			// },
			setUser() {
				this.get('users/me').then((response) => {
					localStorage.setItem('user', JSON.stringify(response.data));
				});
			}
		}
	});
}
